import React from 'react';

const Paginator = (props) => {
    const {onLeftClic, onRightClic, page, totalPages, fromIndex, toIndex, totalDeRegistrosFiltrados} = props;

    return (
        <>
            <div className="d-flex justify-content-between w-99 pagination">
                <div>
                    <a>{fromIndex + 1}–{(toIndex + 1 >= totalDeRegistrosFiltrados) ? totalDeRegistrosFiltrados : toIndex + 1} de {totalDeRegistrosFiltrados}</a>
                </div>
                <div>
                    <a className='previous round page-button' onClick={onLeftClic}>
                        &#8249;
                    </a>
                    <a>
                        {page} de {totalPages}
                    </a>
                    <a className='next round page-button' onClick={onRightClic}>
                        &#8250;
                    </a>
                </div>
            </div>
        </>
    );
};

export default Paginator;
